// ============================================
// INFRASTRUCTURE - Sucursales Repository
// ============================================

import { axiosClient } from './axios-client';
import type { Sucursal, CrearSucursalDto, ActualizarSucursalDto } from '../../domain/dtos';

export const sucursalesRepository = {
  /**
   * Obtener todas las sucursales
   * GET /sucursales
   */
  async obtenerSucursales(): Promise<Sucursal[]> {
    const { data } = await axiosClient.get<Sucursal[]>('/sucursales');
    return data;
  },

  /**
   * Obtener la sucursal actual del usuario autenticado
   * GET /sucursales/current
   */
  async obtenerSucursalActual(): Promise<Sucursal> {
    const { data } = await axiosClient.get<Sucursal>('/sucursales/current');
    return data;
  },

  /**
   * Crear una nueva sucursal
   * POST /sucursales
   */
  async crearSucursal(datos: CrearSucursalDto): Promise<Sucursal> {
    const { data } = await axiosClient.post<Sucursal>('/sucursales', datos);
    return data;
  },

  /**
   * Eliminar una sucursal
   * DELETE /sucursales/{sucursalId}
   */
  async eliminarSucursal(sucursalId: number): Promise<void> {
    await axiosClient.delete(`/sucursales/${sucursalId}`);
  },

  /**
   * Actualizar una sucursal
   * PUT /sucursales/{sucursalId}
   */
  async actualizarSucursal(sucursalId: number, datos: ActualizarSucursalDto): Promise<Sucursal> {
    const { data } = await axiosClient.put<Sucursal>(`/sucursales/${sucursalId}`, datos);
    return data;
  },
};
